import React, { useEffect, useState } from "react";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { proxyAPI } from "../proxyAPI";
import { toast } from "react-toastify";
import JsonCollapse from "../Builder/Components/JsonCollapse";
import { ReportingTopicType } from "../store/slices/reportingSlice";

const builtInTicketStatuses = ["new", "open", "in progress", "closed"];

const customTicketStatuses = (statuses: string[] = []) =>
  statuses.filter(
    (status) =>
      !builtInTicketStatuses.some(
        (builtInStatus) =>
          builtInStatus.toLowerCase() === status.trim().toLowerCase()
      )
  );

export default function TopicForm({
  topic: p_topic,
  handleDelete,
  isDefault,
  setDefault,
}: {
  topic: ReportingTopicType;
  handleDelete: any;
  isDefault: boolean;
  setDefault: () => void;
}) {
  const [topic, setTopic] = useState(p_topic);
  const [isEdited, setIsEdited] = useState(p_topic.isNew);
  const [loading, setLoading] = useState(false);

  const handleChange = (
    field: "label" | "description" | "ticketStatuses" | "isDefault",
    value: any
  ) => {
    setTopic((p) => ({ ...p, [field]: value }));
    setIsEdited(true);
  };

  const handleSave = async () => {
    const data = await proxyAPI({
      prefix: "logic/reporting",
      url: "topics",
      method: "POST",
      body: {
        ...topic,
        ticketStatuses: customTicketStatuses(topic.ticketStatuses),
        isDefault,
      },
      setLoading,
    });
    if (data) {
      setTopic(data);
      toast.success("Saved successfully");
      setIsEdited(false);
    }
  };

  return (
    <div className="">
      <div className="mb-2">
        <Input
          value={[topic.label]}
          onChange={(values: any[]) => handleChange("label", values[0])}
          inputHelp={undefined}
          isMulti={undefined}
          isDisabled={undefined}
          isSearchable={undefined}
          isClearable={undefined}
          options={undefined}
          onKeyUp={undefined}
          onCreateOption={undefined}
          type={undefined}
          isOptionDisabled={undefined}
          min={undefined}
          max={undefined}
          isValidNewOption={undefined}
          loadOptions={undefined}
          getValueLabels={undefined}
          autoFocus={undefined}
          label={"Label"}
          isSummary={undefined}
          configuration={undefined}
          placeholder={undefined}
          maxLength={undefined}
          isContactSet={undefined}
          html={undefined}
          isEmail={undefined}
          dateTimeType={undefined}
          components={undefined}
          maxDate={undefined}
        />
      </div>
      <div className="mb-2">
        <Input
          value={[topic.description]}
          onChange={(values: any[]) => handleChange("description", values[0])}
          inputHelp={undefined}
          isMulti={undefined}
          isDisabled={undefined}
          isSearchable={undefined}
          isClearable={undefined}
          options={undefined}
          onKeyUp={undefined}
          onCreateOption={undefined}
          type={undefined}
          isOptionDisabled={undefined}
          min={undefined}
          max={undefined}
          isValidNewOption={undefined}
          loadOptions={undefined}
          getValueLabels={undefined}
          autoFocus={undefined}
          label={"Description"}
          isSummary={undefined}
          configuration={undefined}
          placeholder={undefined}
          maxLength={undefined}
          isContactSet={undefined}
          html={undefined}
          isEmail={undefined}
          dateTimeType={undefined}
          components={undefined}
          maxDate={undefined}
        />
      </div>
      <div className="mb-2">
        <Input
          value={customTicketStatuses(topic.ticketStatuses)}
          onChange={(values: any[]) => handleChange("ticketStatuses", values)}
          isMulti={true}
          isValidNewOption={(v) => v}
          label={"Ticket statuses"}
          options={undefined}
        />
		<div className="form-text">
			Always available: {builtInTicketStatuses.join(", ")}. These built-in
			statuses cannot be removed.
		</div>
      </div>
      <div className="mb-2">
        <Input
          value={[isDefault]}
          onChange={() => {
            setDefault();
            setIsEdited(true);
          }}
          inputHelp={undefined}
          isMulti={undefined}
          isDisabled={undefined}
          isSearchable={undefined}
          isClearable={undefined}
          options={[
            { value: true, label: "true" },
            { value: false, label: "false" },
          ]}
          onKeyUp={undefined}
          onCreateOption={undefined}
          type={undefined}
          isOptionDisabled={undefined}
          min={undefined}
          max={undefined}
          isValidNewOption={undefined}
          loadOptions={undefined}
          getValueLabels={undefined}
          autoFocus={undefined}
          label={"Is default"}
          isSummary={undefined}
          configuration={undefined}
          placeholder={undefined}
          maxLength={undefined}
          isContactSet={undefined}
          inputType="checkbox"
          html={undefined}
          isEmail={undefined}
          dateTimeType={undefined}
          components={undefined}
          maxDate={undefined}
        />{" "}
      </div>
      <div className="mb-2">
        <div className="text-end">
          <button
            type="button"
            className="btn btn-dark mx-2"
            style={{ width: 100 }}
            onClick={() => handleDelete(topic)}
          >
            Delete topic
          </button>
          {isEdited && (
            <button
              type="button"
              className="btn btn-dark mx-2"
              style={{ width: 100 }}
              onClick={handleSave}
            >
              Save
            </button>
          )}
        </div>
      </div>
      <JsonCollapse json={topic} />
    </div>
  );
}
